import { Card, CardContent, CardHeader } from "@/shared/ui/atoms/Card"
import { Skeleton } from "@/shared/ui/atoms/Skeleton"

export function SkeletonCard() {
  return (
    <Card>
      <CardHeader className="gap-2">
        <Skeleton className="h-4 w-1/3" />
        <Skeleton className="h-4 w-1/4" />
      </CardHeader>
      <CardContent>
        <Skeleton className="h-8 w-2/3" />
      </CardContent>
    </Card>
  )
}
